<template>
  <div id="administracao-microareas">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Microáreas e Distritos"
            description="Adicionar e editar microáreas e distritos sanitários"
            url="/administracao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao=""
            pageIdentifier="microareas"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-end mb-3">
            <b-button variant="primary" @click="abrirModalAdicionar">
              Adicionar microárea <i class="icofont-plus"></i>
            </b-button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros
            :cadastros="cadastros"
            :loading="loading"
            @editar="editarMicroArea"
            @agente-saude="abrirModalAgenteSaude"
            @editar-distrito="abrirModalEditarDistrito"
          />
        </div>
      </div>
    </div>

    <ModalMicroArea
      ref="modalMicroArea"
      :modal-mode="modalMode"
      :modal-loading="modalLoading"
      :loading-select-estabelecimento="loadingSelectEstabelecimento"
      :ubs-options="ubsOptions"
      :equipes-options="equipesOptions"
      :localidade-options="localidadeOptions"
      :district-options="distritosOptions"
      :form="form"
      @salvar="salvarMicroArea"
      @inativar="inativarMicroArea"
      @reativar="reativarMicroArea"
      @hidden="resetForm"
    />

    <ModalAgenteSaude
      ref="modalAgenteSaude"
      :modal-loading="modalAgenteLoading"
      :micro-area="microAreaSelecionadaAgente"
      :agente-ativo="agenteAtivo"
      :historico="historicoAgentes"
      :profissionais-options="acsOptionsModalAgente"
      @hidden="resetModalAgenteSaude"
      @substituir="salvarVinculoAgente"
      @atualizar-vinculo="atualizarVinculoAgente"
      @encerrar-vinculo="encerrarVinculoAgente"
    />

    <ModalDistrito
      ref="modalDistrito"
      :district-options="distritosOptions"
      :modal-loading="modalDistritoLoading"
      :form="formDistrito"
      @salvar="salvarDistrito"
      @hidden="resetModalDistrito"
    />

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import TabelaCadastros from './TabelaCadastros.vue'
import SectionTitle from '@/components/SectionTitle'
import ModalMicroArea from './components/ModalMicroArea.vue'
import ModalAgenteSaude from './components/ModalAgenteSaude.vue'
import ModalDistrito from './components/ModalDistrito.vue'

export default {
  metaInfo: {
    title: 'Microáreas',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    TabelaCadastros,
    SectionTitle,
    ModalMicroArea,
    ModalAgenteSaude,
    ModalDistrito,
  },
  data() {
    return {
      cadastros: [],
      loading: false,
      form: {
        ubs: null,
        equipe: null,
        microarea: null,
        localidade: null,
        quantidadePessoas: null,
        observacoes: null,
        ativo: 1,
        distritoSelecionado: 'nao-se-aplica',
        distritoForm: {
          no_distrito: null,
          cpf_gerente: null,
          no_gerente: null,
          ativo: 1,
          anotacoes: null,
        },
      },
      formDistrito: {
        id: null,
        no_distrito: null,
        cpf_gerente: null,
        no_gerente: null,
        ativo: 1,
        anotacoes: null,
      },
      modalMode: 'create',
      modalLoading: false,
      modalDistritoLoading: false,
      microAreaSelecionada: null,
      microAreaSelecionadaDistrito: null,
      loadingSelectEstabelecimento: false,
      ubsOptions: [],
      localidadeOptions: [
        {
          label: 'Urbana',
          value: 'Urbana',
        },
        {
          label: 'Periurbana',
          value: 'Periurbana',
        },
        {
          label: 'Rural',
          value: 'Rural',
        },
      ],
      modalAgenteLoading: false,
      agenteAtivo: null,
      historicoAgentes: [],
      microAreaSelecionadaAgente: null,
      profissionaisOptions: [],
      acsOptionsModalAgente: [],
      distritosOptions: [],
    }
  },
  computed: {
    equipesOptions() {
      return this.$store.state.equipesV2 ?? []
    },
  },
  async mounted() {
    await this.buscarMicroAreas()
    await this.carregarSelectEstabelecimento()
    await this.carregarProfissionaisDeSaude()
    await this.buscarDistritos()
  },
  methods: {
    /**
     * Busca as microáreas
     */
    async buscarMicroAreas() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/microareas/' + this.$store.state.cod_ibge + '/microareas'
        )

        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Busca os estabelecimentos de saúde
     */
    async carregarSelectEstabelecimento() {
      try {
        this.loadingSelectEstabelecimento = true
        const response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/unidades-de-saude`
        )

        if (response) {
          this.ubsOptions = response.data.filter((el) => el.ines_aps != null)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSelectEstabelecimento = false
      }
    },

    /**
     * Abre o modal de adicionar/atualizar microárea
     */
    abrirModalAdicionar() {
      this.resetForm()
      this.modalMode = 'create'
      this.$refs.modalMicroArea.abrir()
    },

    /**
     * Reseta o formulário de adicionar/atualizar microárea
     */
    resetForm() {
      this.form = {
        ubs: null,
        equipe: null,
        microarea: null,
        localidade: null,
        quantidadePessoas: null,
        observacoes: null,
        ativo: 1,
        distritoSelecionado: 'nao-se-aplica',
        distritoForm: {
          no_distrito: null,
          cpf_gerente: null,
          no_gerente: null,
          ativo: 1,
          anotacoes: null,
        },
      }
      this.microAreaSelecionada = null
      this.modalMode = 'create'
      this.modalLoading = false
    },

    /**
     * Reseta o formulário do distrito
     */
    resetModalDistrito() {
      this.formDistrito = {
        id: null,
        no_distrito: null,
        cpf_gerente: null,
        no_gerente: null,
        ativo: 1,
        anotacoes: null,
      }

      this.microAreaSelecionadaDistrito = null
      this.modalDistritoLoading = false
    },

    /**
     * Edita uma microárea
     *
     * @param {Object} item Dados da microárea
     * @return {Promise<void>}
     */
    async editarMicroArea(item) {
      try {
        this.resetForm()
        this.modalMode = 'edit'
        this.modalLoading = true
        this.microAreaSelecionada = item

        const equipeSelecionada = this.equipesOptions.find((el) => {
          return el.ine_esf_eap == item.ine
        })

        const ubsSelecionada = this.ubsOptions.find((ubs) => {
          return ubs.nu_cnes == item.cnes
        })

        const localidadeSelecionada = this.localidadeOptions.find(
          (localidade) => {
            return localidade.value == item.localidade
          }
        )

        const possuiDistrito = Boolean(item.id_distrito_sanitario)

        this.form = {
          ubs: ubsSelecionada || null,
          equipe: equipeSelecionada || null,
          microarea: item.nu_micro_area || null,
          localidade: localidadeSelecionada || null,
          quantidadePessoas: item.estimativa_cadastro || null,
          observacoes: item.anotacoes || null,
          ativo: item.ativo,
          distritoSelecionado: possuiDistrito
            ? item.id_distrito_sanitario
            : 'nao-se-aplica',
          distritoForm: {
            no_distrito: null,
            cpf_gerente: null,
            no_gerente: null,
            ativo: 1,
            anotacoes: null,
          },
        }

        this.$refs.modalMicroArea.abrir()
      } catch (error) {
        console.log(error)
      } finally {
        this.modalLoading = false
      }
    },

    /**
     * Abre modal para editar distrito da microárea
     *
     * @param {Object} item Dados da microárea
     * @return {void}
     */
    abrirModalEditarDistrito(item) {
      // if (!item?.id_distrito_sanitario) {
      //   this.$toast.error('Essa microárea não possui distrito vinculado.')
      //   return
      // }

      this.microAreaSelecionadaDistrito = item
      this.formDistrito = {
        id: item.id_distrito_sanitario,
        no_distrito: item.distrito_nome || null,
        cpf_gerente: item.distrito_cpf_gerente || null,
        no_gerente: item.distrito_nome_gerente || null,
        ativo: item.distrito_ativo ?? 1,
        anotacoes: item.distrito_anotacoes || null,
      }

      this.$refs.modalDistrito.abrir()
    },

    /**
     * Salva a microárea
     *
     * @param {Object} params
     * @param {Object} params.form Dados do formulário
     * @param {Function} params.onSuccess Callback de sucesso
     * @param {Function} params.onError Callback de erro
     * @param {Function} params.onFinally Callback executado ao final
     * @return {Promise<void>}
     */
    async salvarMicroArea({ form, onSuccess, onError, onFinally }) {
      try {
        let idDistritoSanitario = null

        if (form.distritoSelecionado === 'nao-se-aplica') {
          idDistritoSanitario = null
        } else if (form.distritoSelecionado === 'inserir-distrito') {
          const distritoResponse = await this.cadastrarDistrito(
            form.distritoForm
          )

          if (!distritoResponse.id) {
            onError(
              distritoResponse.message ||
                'Erro ao cadastrar distrito sanitário.'
            )
            return
          }

          idDistritoSanitario = distritoResponse.id
        }

        const payload = {
          cnes: form.ubs.nu_cnes,
          ine: form.equipe.ine_esf_eap,
          nu_micro_area: form.microarea,
          localidade: form.localidade.value,
          estimativa_cadastro: form.quantidadePessoas,
          anotacoes: form.observacoes,
          ativo: form.ativo,
          id_distrito_sanitario: idDistritoSanitario,
          quem_atualizou: this.$store.state.username,
        }

        let response = null

        if (this.modalMode === 'edit' && this.microAreaSelecionada?.id) {
          response = await this.$api.put(
            `/app/microareas/${this.$store.state.cod_ibge}/${this.microAreaSelecionada.id}`,
            payload
          )
        } else {
          response = await this.$api.post(
            `/app/microareas/${this.$store.state.cod_ibge}`,
            payload
          )
        }

        const data = response?.data || {}

        if (data.error === false) {
          onSuccess(
            data.message ||
              (this.modalMode === 'edit'
                ? 'Microárea atualizada com sucesso!'
                : 'Microárea cadastrada com sucesso!')
          )

          await this.buscarMicroAreas()
          await this.buscarDistritos()

          if (this.modalMode === 'edit') {
            setTimeout(() => {
              this.$refs.modalMicroArea.fechar()
            }, 800)
          }

          return
        }

        onError(
          data.message ||
            (this.modalMode === 'edit'
              ? 'Erro ao atualizar microárea.'
              : 'Erro ao cadastrar microárea.')
        )
      } catch (error) {
        console.log(error)
        onError(
          this.modalMode === 'edit'
            ? 'Erro ao atualizar microárea.'
            : 'Erro ao cadastrar microárea.'
        )
      } finally {
        onFinally()
      }
    },

    /**
     * Salva edição ou cadastro do distrito
     *
     * @param {Object} params Dados do modal
     * @param {Object} params.form Dados do formulário
     * @param {Function} params.onSuccess Callback de sucesso
     * @param {Function} params.onError Callback de erro
     * @param {Function} params.onFinally Callback final
     * @return {Promise<void>}
     */
    async salvarDistrito({ form, onSuccess, onError, onFinally }) {
      try {
        const payload = {
          no_distrito: form.no_distrito,
          cpf_gerente: form.cpf_gerente,
          no_gerente: form.no_gerente,
          ativo: form.ativo,
          anotacoes: form.anotacoes,
          quem_atualizou: this.$store.state.username,
        }

        let response = null

        if (form.isNovoDistrito) {
          response = await this.$api.post(
            `/app/microareas/${this.$store.state.cod_ibge}/distritos`,
            payload
          )
        } else {
          response = await this.$api.put(
            `/app/microareas/${this.$store.state.cod_ibge}/distritos/${form.id}`,
            payload
          )
        }

        const data = response?.data || {}

        if (data.error === false) {
          onSuccess(
            data.message ||
              (form.isNovoDistrito
                ? 'Distrito cadastrado com sucesso!'
                : 'Distrito atualizado com sucesso!')
          )

          await this.buscarMicroAreas()
          await this.buscarDistritos()

          setTimeout(() => {
            this.$refs.modalDistrito.fechar()
          }, 800)

          return
        }

        onError(
          data.message ||
            (form.isNovoDistrito
              ? 'Erro ao cadastrar distrito.'
              : 'Erro ao atualizar distrito.')
        )
      } catch (error) {
        console.log(error)
        onError(
          form.isNovoDistrito
            ? 'Erro ao cadastrar distrito.'
            : 'Erro ao atualizar distrito.'
        )
      } finally {
        onFinally()
      }
    },

    /**
     * Inativar microárea
     */
    async inativarMicroArea({ form, onSuccess, onError, onFinally }) {
      try {
        if (!this.microAreaSelecionada?.id) {
          onError('Microárea não encontrada para inativação.')
          return
        }

        const payload = {
          cnes: form.ubs.nu_cnes,
          ine: form.equipe.ine_esf_eap,
          nu_micro_area: form.microarea,
          localidade: form.localidade.value,
          estimativa_cadastro: form.quantidadePessoas,
          anotacoes: form.observacoes,
          ativo: 0,
          quem_atualizou: this.$store.state.username,
        }

        const response = await this.$api.put(
          `/app/microareas/${this.$store.state.cod_ibge}/${this.microAreaSelecionada.id}`,
          payload
        )

        const data = response?.data || {}

        if (data.error === false) {
          onSuccess('Microárea inativada com sucesso!')
          await this.buscarMicroAreas()

          setTimeout(() => {
            this.$refs.modalMicroArea.fechar()
          }, 800)

          return
        }

        onError('Erro ao inativar microárea.')
      } catch (error) {
        console.log(error)
        onError('Erro ao inativar microárea.')
      } finally {
        onFinally()
      }
    },

    /**
     * Reativar microárea
     */
    async reativarMicroArea({ form, onSuccess, onError, onFinally }) {
      try {
        if (!this.microAreaSelecionada?.id) {
          onError('Microárea não encontrada para reativação.')
          return
        }

        const payload = {
          cnes: form.ubs.nu_cnes,
          ine: form.equipe.ine_esf_eap,
          nu_micro_area: form.microarea,
          localidade: form.localidade.value,
          estimativa_cadastro: form.quantidadePessoas,
          anotacoes: form.observacoes,
          ativo: 1,
          quem_atualizou: this.$store.state.username,
        }

        const response = await this.$api.put(
          `/app/microareas/${this.$store.state.cod_ibge}/${this.microAreaSelecionada.id}`,
          payload
        )

        const data = response?.data || {}

        if (data.error === false) {
          onSuccess('Microárea reativada com sucesso!')
          await this.buscarMicroAreas()

          setTimeout(() => {
            this.$refs.modalMicroArea.fechar()
          }, 800)

          return
        }

        onError('Erro ao reativar microárea.')
      } catch (error) {
        console.log(error)
        onError('Erro ao reativar microárea.')
      } finally {
        onFinally()
      }
    },

    /** Abre o modal de agente de saúde */
    async abrirModalAgenteSaude(item) {
      if (String(item.nu_micro_area) === 'FA') {
        this.$toast.error(
          'Não é permitido vincular agente de saúde à microárea FA.'
        )
        return
      }

      try {
        this.modalAgenteLoading = true
        this.microAreaSelecionadaAgente = item

        const cbosPermitidos = ['515105', '322255']

        this.acsOptionsModalAgente = this.profissionaisOptions.filter(
          (profissional) => {
            return (
              profissional.nu_ine == item.ine &&
              cbosPermitidos.includes(String(profissional.co_cbo))
            )
          }
        )

        const profissionaisVinculados = JSON.parse(item.profissionais) || []

        this.agenteAtivo =
          profissionaisVinculados.find((profissional) => {
            return Number(profissional.ativo) === 1
          }) || null

        this.historicoAgentes = profissionaisVinculados.filter(
          (profissional) => {
            return Number(profissional.ativo) !== 1
          }
        )

        this.$refs.modalAgenteSaude.abrir()
      } catch (error) {
        console.log(error)
      } finally {
        this.modalAgenteLoading = false
      }
    },

    /** Reseta o estado do modal de agente de saúde */
    resetModalAgenteSaude() {
      this.modalAgenteLoading = false
      this.microAreaSelecionadaAgente = null
      this.agenteAtivo = null
      this.historicoAgentes = []
      this.acsOptionsModalAgente = []
    },

    /**
     * Salva vínculo de agente de saúde
     *
     * @param {Object} params
     * @param {Object} params.microArea Microárea selecionada
     * @param {Object|null} params.agenteAtual Agente atualmente vinculado (se houver)
     * @param {Object} params.novoAgente Novo agente selecionado
     * @param {string} params.data_inicio Data de início do vínculo
     * @param {String} params.anotacoes Anotações
     * @param {Function} params.onSuccess Callback de sucesso
     * @param {Function} params.onError Callback de erro
     */
    async salvarVinculoAgente({
      microArea,
      agenteAtual,
      novoAgente,
      data_inicio,
      anotacoes,
      onSuccess,
      onError,
    }) {
      try {
        const payload = {
          id_profissional:
            novoAgente.co_dim_profissional ??
            novoAgente.id_profissional ??
            null,
          cpf_profissional:
            novoAgente.nu_cpf ?? novoAgente.cpf_profissional ?? null,
          no_profissional:
            novoAgente.no_profissional ?? novoAgente.nome_profissional ?? null,
          data_inicio: data_inicio,
          data_fim: novoAgente.dt_desativacao ?? null,
          anotacoes,
          ativo: 1,
          quem_atualizou: this.$store.state.username,
        }

        const response = await this.$api.post(
          `/app/microareas/${this.$store.state.cod_ibge}/microareas/${microArea.id}/profissional`,
          payload
        )

        const data = response?.data || {}

        if (data.error === false) {
          onSuccess(data.message || 'Profissional vinculado com sucesso!')

          await this.buscarMicroAreas()

          const microAreaAtualizada = this.cadastros.find((item) => {
            return String(item.id) === String(microArea.id)
          })

          if (microAreaAtualizada) {
            this.microAreaSelecionadaAgente = microAreaAtualizada

            const profissionaisVinculados =
              JSON.parse(microAreaAtualizada.profissionais) || []

            this.agenteAtivo =
              profissionaisVinculados.find((profissional) => {
                return Number(profissional.ativo) === 1
              }) || null

            this.historicoAgentes = profissionaisVinculados.filter(
              (profissional) => {
                return Number(profissional.ativo) !== 1
              }
            )
          }

          return
        }

        onError(data.message || 'Erro ao salvar vínculo do profissional.')
      } catch (error) {
        console.log(error)
        onError('Erro ao salvar vínculo do profissional.')
      }
    },

    /**
     * Encerra vínculo de agente de saúde
     *
     * @param {Object} params
     * @param {Object} params.microArea Microárea selecionada
     * @param {Object} params.agenteAtivo Agente atualmente ativo
     * @param {string} params.data_fim Data de encerramento do vínculo
     * @param {String} params.anotacoes Anotações
     * @param {Function} params.onSuccess Callback de sucesso
     * @param {Function} params.onError Callback de erro
     */
    async encerrarVinculoAgente({
      microArea,
      agenteAtivo,
      data_fim,
      anotacoes,
      onSuccess,
      onError,
    }) {
      try {
        const payload = {
          cpf_profissional: agenteAtivo.cpf_profissional,
          data_fim,
          anotacoes,
          quem_atualizou: this.$store.state.username,
        }

        const response = await this.$api.post(
          `/app/microareas/${this.$store.state.cod_ibge}/microareas/${microArea.id}/profissional/encerrar`,
          payload
        )

        const data = response?.data || {}

        if (data.error === false) {
          onSuccess(data.message || 'Vínculo encerrado com sucesso!')

          await this.buscarMicroAreas()

          const microAreaAtualizada = this.cadastros.find((item) => {
            return String(item.id) === String(microArea.id)
          })

          if (microAreaAtualizada) {
            this.microAreaSelecionadaAgente = microAreaAtualizada

            const profissionaisVinculados =
              JSON.parse(microAreaAtualizada.profissionais) || []

            this.agenteAtivo =
              profissionaisVinculados.find((profissional) => {
                return Number(profissional.ativo) === 1
              }) || null

            this.historicoAgentes = profissionaisVinculados.filter(
              (profissional) => {
                return Number(profissional.ativo) !== 1
              }
            )
          }

          return
        }

        onError(data.message || 'Erro ao encerrar vínculo do agente.')
      } catch (error) {
        console.log(error)
        onError('Erro ao encerrar vínculo do agente.')
      }
    },

    /**
     * Atualiza o vínculo ativo do agente de saúde
     *
     * @param {Object} params
     * @param {Object} params.microArea Microárea selecionada
     * @param {Object} params.agenteAtivo Agente atualmente ativo
     * @param {string} params.data_inicio Nova data inicial do vínculo
     * @param {string} params.anotacoes Anotações
     * @param {Function} params.onSuccess Callback de sucesso
     * @param {Function} params.onError Callback de erro
     */
    async atualizarVinculoAgente({
      microArea,
      agenteAtivo,
      data_inicio,
      anotacoes,
      onSuccess,
      onError,
    }) {
      try {
        const payload = {
          cpf_profissional: agenteAtivo.cpf_profissional,
          data_inicio,
          anotacoes,
          quem_atualizou: this.$store.state.username,
        }

        const response = await this.$api.put(
          `/app/microareas/${this.$store.state.cod_ibge}/microareas/${microArea.id}/profissional`,
          payload
        )

        const data = response?.data || {}

        if (data.error === false) {
          onSuccess(data.message || 'Vínculo atualizado com sucesso!')

          await this.buscarMicroAreas()

          const microAreaAtualizada = this.cadastros.find((item) => {
            return String(item.id) === String(microArea.id)
          })

          if (microAreaAtualizada) {
            this.microAreaSelecionadaAgente = microAreaAtualizada

            const profissionaisVinculados =
              JSON.parse(microAreaAtualizada.profissionais) || []

            this.agenteAtivo =
              profissionaisVinculados.find((profissional) => {
                return Number(profissional.ativo) === 1
              }) || null

            this.historicoAgentes = profissionaisVinculados.filter(
              (profissional) => {
                return Number(profissional.ativo) !== 1
              }
            )
          }

          return
        }

        onError(data.message || 'Erro ao atualizar vínculo do profissional.')
      } catch (error) {
        console.log(error)
        onError('Erro ao atualizar vínculo do profissional.')
      }
    },

    /**
     * Cadastra um novo distrito sanitário
     *
     * @param {Object} distrito Dados do distrito
     * @return {Promise<Object>}
     */
    async cadastrarDistrito(distrito) {
      const payload = {
        no_distrito: distrito.no_distrito,
        cpf_gerente: distrito.cpf_gerente,
        no_gerente: distrito.no_gerente,
        ativo: distrito.ativo,
        anotacoes: distrito.anotacoes,
        quem_atualizou: this.$store.state.username,
      }

      const response = await this.$api.post(
        `/app/microareas/${this.$store.state.cod_ibge}/distritos`,
        payload
      )

      const data = response?.data || {}

      return {
        id: data?.id ?? data?.data?.id ?? data?.distrito?.id ?? null,
        message: data?.message ?? null,
        error: data?.error ?? false,
      }
    },

    /**
     * Atualiza um distrito sanitário
     *
     * @param {Object} distrito Dados do distrito
     * @return {Promise<number|null>}
     */
    async atualizarDistrito(distrito) {
      const payload = {
        no_distrito: distrito.no_distrito,
        cpf_gerente: distrito.cpf_gerente,
        no_gerente: distrito.no_gerente,
        ativo: distrito.ativo,
        anotacoes: distrito.anotacoes,
        quem_atualizou: this.$store.state.username,
      }

      const response = await this.$api.put(
        `/app/microareas/${this.$store.state.cod_ibge}/distritos/${distrito.id}`,
        payload
      )

      return (
        response?.data?.id ??
        response?.data?.data?.id ??
        response?.data?.distrito?.id ??
        null
      )
    },

    /** Carrega profissionais de saúde */
    async carregarProfissionaisDeSaude() {
      try {
        const { data } = await this.$api.get(
          `/app/municipio/${this.$store.state.cod_ibge}/profissionais-saude`
        )

        this.profissionaisOptions = data || []
      } catch (error) {
        console.log(error)
        return []
      }
    },

    /**
     * Busca os distritos disponíveis para o select
     *
     * @return {Promise<void>}
     */
    async buscarDistritos() {
      try {
        const response = await this.$api.get(
          `/app/microareas/${this.$store.state.cod_ibge}/distritos`
        )

        const distritos = response?.data.items || []

        this.distritosOptions = [
          { id: 'nao-se-aplica', no_distrito: 'Não se aplica' },
          ...distritos,
          { id: 'inserir-distrito', no_distrito: '+ Inserir novo distrito' },
        ]
      } catch (error) {
        console.log(error)
        this.distritosOptions = [
          { id: 'nao-se-aplica', no_distrito: 'Não se aplica' },
          { id: 'inserir-distrito', no_distrito: '+ Inserir novo distrito' },
        ]
      }
    },
  },
}
</script>
